export const globalMap = new Map<string, any>();
export const factoryMap = new Map<string, any>();
